module.exports = __webpack_public_path__ + "media/game_end_1.49997cee.mp3";